module.exports = __webpack_public_path__ + "img/1.3220cfa2.png";